export const environment = {
    production: false,
    stage: 0,
    scope: "api://9284d001-e6df-4024-ae1b-8e7e3b035f35/Test",
    endpoint: "https://stabletkebbxbackofficebackend.azurewebsites.net/",
    clientId: "6d3faba4-cd63-4d7a-a6dc-93334cbd8805",
    authority: "https://login.microsoftonline.com/devtkebbx.onmicrosoft.com"
};